<template>
  <div>
    <h2 class="subtitle">Options du site internet</h2>
    <hr />
    <website_connection></website_connection>
  </div>
</template>

<script>
  import Website_connection from "./Website_connection";
  export default {
    name: 'WebsiteTech',
    components: {Website_connection},
  };
</script>

<style scoped>

</style>
